// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aeronautical-information-publications.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aeronautical-information-publications/aeronautical-information-publications.js';

mount([g0]);
